import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import * as Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import DCommercialInfo from '@components/organisms/DCommercialInfo.vue';
import DObjectProgress from '@components/organisms/DObjectProgress.vue';
import VueSmoothScroll from 'vue3-smooth-scroll';

$(window).on('load', () => {
  Vue.createApp({components: {DCommercialInfo}}).use(VueAxios, axios).use(VueSmoothScroll).mount('#commercial-info');

  const progressEl = document.querySelector('#object-progress');
  if (progressEl) {
    Vue.createApp({components: {DObjectProgress}}).use(VueAxios, axios).mount('#object-progress');
  }
});

new Swiper('[data-commercial-object-slider]', {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 0,
  pagination: {
    el: '[data-commercial-object-slider-pagination]',
    type: 'custom',
    renderCustom: function(swiper, current, total) {
      let currentSlide = current.toString();
      let totalSlide = total.toString();
      return `<span>${ currentSlide }&nbsp;-&nbsp;${ totalSlide }</span>`;
    },
  },
  navigation: {
    nextEl: '.commercialObject._next',
    prevEl: '.commercialObject._prev',
  },
});
